import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { BarChart3, CalendarPlus, ChevronRight, ListChecks } from "lucide-react";

export function QuickAccessLinks() {
  const navigate = useNavigate();
  const { t } = useTranslation("athlete");

  const links = [
    {
      icon: CalendarPlus,
      label: t("dashboard.quickBook"),
      sub: t("dashboard.quickBookSub", { defaultValue: "une séance" }),
      path: "/athlete/schedule",
    },
    {
      icon: ListChecks,
      label: t("dashboard.quickSessions"),
      sub: t("dashboard.quickSessionsSub", { defaultValue: "voir mes réservations" }),
      path: "/athlete/reservations",
    },
    {
      icon: BarChart3,
      label: t("dashboard.quickProgress"),
      sub: t("dashboard.quickProgressSub", { defaultValue: "voir mes stats" }),
      path: "/athlete/stats",
    },
  ];

  return (
    <div className="grid grid-cols-3 gap-2">
      {links.map((link) => (
        <button
          key={link.path}
          onClick={() => navigate(link.path)}
          className="athlete-quick-link flex min-w-0 flex-col gap-3 px-3 py-3 text-left transition-all active:scale-[0.97]"
        >
          <link.icon className="h-5 w-5 text-primary shrink-0" />
          <div className="flex w-full items-center justify-between gap-1">
            <div className="min-w-0">
              <p className="truncate text-xs font-semibold text-foreground">
                {link.label}
              </p>
              <p className="truncate text-[10px] text-muted-foreground">
                {link.sub}
              </p>
            </div>
            <ChevronRight className="h-3.5 w-3.5 shrink-0 text-muted-foreground" />
          </div>
        </button>
      ))}
    </div>
  );
}
